const DownloadIcon = ({ outline }: { outline?: boolean }) => {
  if (outline) {
    return (
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 16 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.625 6.625C13.7296 6.625 14.625 7.52043 14.625 8.625V16.625C14.625 17.7296 13.7296 18.625 12.625 18.625H2.625C1.52043 18.625 0.625 17.7296 0.625 16.625V8.625C0.625 7.52043 1.52043 6.625 2.625 6.625M7.625 0.625L7.6251 12.625M7.6251 12.625L4.625 9.7614M7.6251 12.625L10.625 9.7614"
          stroke="black"
          stroke-width="1.25"
          stroke-linecap="round"
        />
      </svg>
    );
  }
  return (
    <svg
      stroke={outline ? "black" : "currentColor"}
      fill={outline ? "black" : "currentColor"}
      stroke-width="0"
      viewBox="0 0 384 512"
      height="16px"
      width="16px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm76.45 211.36l-96.42 95.7c-6.65 6.61-17.39 6.61-24.04 0l-96.42-95.7C73.42 337.29 80.54 320 94.82 320H160v-80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v80h65.18c14.28 0 21.4 17.29 11.27 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"></path>
    </svg>
  );
};

export default DownloadIcon;
